import { api } from "../../../services/api";
import { loginSchema, validateWithSchema } from "../../../security/validation";

export async function loginRequest({ username, password }) {
  const payload = validateWithSchema(loginSchema, { username, password });
  const response = await api.post("/api/login/", payload);
  const data = response.data;

  if (!data?.token && data?.auth_mode !== "cookie") {
    throw new Error("Resposta de autenticação inválida.");
  }

  return data;
}
